var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 28.571,
    viewBox: "0 0 40 28.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-cash",
    "data-name": "Icon ionic-md-cash",
    transform: "translate(-2.25 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7290",
    "data-name": "Trazado 7290",
    d: "M2.25,6.75V29.607h40V6.75Zm14.33,20H9.4a4.291,4.291,0,0,0-4.295-4.295V15.321a5.72,5.72,0,0,0,5.714-5.714H16.58a13.331,13.331,0,0,0-2.9,8.571A13.331,13.331,0,0,0,16.58,26.75Zm22.812-4.295a4.318,4.318,0,0,0-4.286,4.295H27.92a13.331,13.331,0,0,0,2.9-8.571,13.331,13.331,0,0,0-2.9-8.571h5.759a5.72,5.72,0,0,0,5.714,5.714Z",
    fill: "#e8339e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7291",
    "data-name": "Trazado 7291",
    d: "M2.25,27h40v2.857h-40Z",
    transform: "translate(0 5.464)",
    fill: "#e8339e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.13939652ab5fd9b1321911ae1bb50a91.svg";
export { ForwardRef as ReactComponent };